import { Box, Stack, Typography } from '@mui/material';
import { useBreakpoints } from 'modules/common/hooks/useBreakpoints';
import { default as SonicLogoIcon } from '../../assets/sonicColorfull.svg?react';
import { default as LombardIcon } from '../../assets/lombard.svg?react';
import { default as ChainIcon } from '../../assets/chain.svg?react';

export function Header(): JSX.Element {
  const { isSmDown } = useBreakpoints();

  return (
    <Stack
      gap={2.5}
      alignItems="center"
      sx={{
        alignItems: 'center',
      }}
    >
      <Stack
        sx={{
          borderRadius: '1000px',
          border: '1px solid rgba(255, 255, 255, 0.10)',

          background: 'rgba(0, 0, 0, 0.20)',

          backdropFilter: 'blur(4px)',
          padding: 1,
        }}
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        gap={2}
      >
        <Box component={SonicLogoIcon} sx={{ height: isSmDown ? 56 : 72 }} />
        <Box component={ChainIcon} sx={{ height: isSmDown ? 32 : 32 }} />

        <Box
          component={LombardIcon}
          sx={{
            height: isSmDown ? 56 : 72,
          }}
        />
      </Stack>
      <Box>
        <Typography variant="h4" textAlign="center">
          Bitcoin Sonic Vault
        </Typography>
        <Typography variant="subtitle2" fontWeight={400} textAlign="center">
          Deposit into the Sonic Vault to benefit from the top yield
          opportunities.
        </Typography>
      </Box>
    </Stack>
  );
}
